import { OfferItem, Loading } from "components";
import flowRight from "lodash/flowRight";
import sortBy from "lodash/sortBy";
import {
  fetchOffers,
  makeSelectOffers,
  makeSelectLoading,
  makeSelectQty,
} from "logic/orders";
import React, { Component } from "react";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "i18n/messages";
import { withRouter } from "next/router";

const LoadingOffer = () => (
  <div className="card mt-4 mb-4 p-4 loading-wrap">
    <Loading />
    <div className="text">
      <FormattedMessage {...messages.retrievingSeatsAndPrices} />
    </div>
  </div>
);

class AvailableTicketsListing extends Component {
  lastQty = null;

  static propTypes = {
    date: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.props.actions.fetchOffers(this.props.id);
    this.lastQty = this.props.qty || 2;
  }

  componentDidUpdate() {
    if (this.lastQty === this.props.qty) return;
    if (this.props.qty < 1) return;

    this.lastQty = this.props.qty;
    this.props.actions.fetchOffers(this.props.id);
  }

  handleNavToSpl = () =>
    this.props.router.push(this.props.router.asPath.replace("/b/", "/b/spl/"));

  renderOnlyRestSeatsVisitSeatingPlan = () => (
    <div className="tt-shop-available-prices">
      <div className="tt-offer-item">
        <div className="only-rest-seats">
          <div className="info-text">
            <FormattedMessage {...messages.onlyRestSeatsVisitSpl} />
          </div>
          <div className="btn-wrap">
            <Button outline color="primary" onClick={this.handleNavToSpl}>
              <FormattedMessage {...messages.goToSeatingPlan} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  totalQtyOfOfferedSeats = (offers) =>
    offers.reduce(
      (acc, offer) => acc + (offer.seat_ids ? offer.seat_ids.length : 0),
      0
    );

  render() {
    const { loading, offers, date } = this.props;
    if (loading) return <LoadingOffer />;

    if (this.totalQtyOfOfferedSeats(offers) < 1 && date.spl_enabled)
      return this.renderOnlyRestSeatsVisitSeatingPlan();

    return (
      <div className="tt-shop-available-prices">
        {(sortBy(offers, (pct) => pct.price_category_num) || [{}, {}]).map(
          (offer, index) => (
            <OfferItem {...{ offer }} date={date} key={`offer-${index}`} />
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  offers: makeSelectOffers(),
  loading: makeSelectLoading(),
  qty: makeSelectQty(),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchOffers,
    },
    dispatch
  ),
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
);

export default enhance(AvailableTicketsListing);
